__turbopack_context__.v({
  "Caption": "Gallery-module-sass-module__PeT-BW__Caption",
  "Gallery": "Gallery-module-sass-module__PeT-BW__Gallery",
  "GalleryImage": "Gallery-module-sass-module__PeT-BW__GalleryImage",
  "Main": "Gallery-module-sass-module__PeT-BW__Main",
});
